import { render } from "./NoticesInput.vue?vue&type=template&id=078b4fa7"
import script from "./NoticesInput.vue?vue&type=script&lang=js"
export * from "./NoticesInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__